import { localStorageLabels } from '@/utils/constants';

// The last schedule bundle is kept so a screen that boots without network can play the horizon
// it already has (its media is in the content cache).

export const saveBundle = (bundle, clockOffsetMs) => {
  try {
    localStorage.setItem(
      localStorageLabels.BUNDLE,
      JSON.stringify({ bundle, clockOffsetMs }),
    );
  } catch {
    // Storage full or unavailable: playback still works while online.
  }
};

export const loadBundle = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(localStorageLabels.BUNDLE));
    return stored?.bundle?.days ? stored : null;
  } catch {
    return null;
  }
};

export const clearBundle = () => {
  try {
    localStorage.removeItem(localStorageLabels.BUNDLE);
  } catch {
    // ignore
  }
};
